import { withTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import Button from '@/ui/Button'
import Icon from '@/ui/Icon'

import useCheckout from '../../hooks/useCheckout'
import CheckoutStep from '../CheckoutStep'
import {
  SummaryAddon,
  SummaryAddonIcon,
  SummaryAddonText,
  SummaryCaption,
  SummaryNumber,
  SummaryTitle,
  SummaryWrapper
} from './Summary.styles'

const Summary = ({ t }) => {
  const { cart, pickupOrderNumber } = useCheckout()

  const navigate = useNavigate()
  return (
    <CheckoutStep fullwidth={true}>
      <SummaryWrapper>
        {/* <SummaryComposition>
          <Marquee spacing={100} speed={0.75}>
            <SummaryCompositionText>{t('orderSuccessWatermark')}</SummaryCompositionText>
          </Marquee>
          <SummaryCompositionImagesWrapper>
            {cart
              .slice(0, 2)
              .map((item, index) => item.imageUrl && <SummaryCompositionImage key={index} padded={index === 1} src={item.imageUrl} />)}
          </SummaryCompositionImagesWrapper>
        </SummaryComposition> */}
        <SummaryTitle>{t('orderSuccessTitle')}</SummaryTitle>
        <SummaryCaption>{t('yourOrdersNumber')}</SummaryCaption>
        <SummaryNumber>{pickupOrderNumber}</SummaryNumber>
        <SummaryAddon>
          <SummaryAddonIcon>
            <Icon name="info" />
          </SummaryAddonIcon>
          <SummaryAddonText>{t('orderSuccessAddon')}</SummaryAddonText>
        </SummaryAddon>
        <Button onClick={() => navigate('/')} size="xl">
          {t('finish')}
        </Button>
      </SummaryWrapper>
    </CheckoutStep>
  )
}

export default withTranslation()(Summary)
